import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=8661c916&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=js&"
export * from "./CouponList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661c916",
  null
  
)

export default component.exports